// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        "main-title": "Spy Chess",
        "instagram": "Instagram",
        "youtube": "YouTube",
        "tiktok": "TikTok",
        "website": "Website",
        "facebook": "Facebook",
        "X": "X",
        "google-play": "Google Play",
        "app-store": "App Store",
        "rules": "Rules",
        "rules-title": "Spy Chess Rules",
        "rules_1": "Recruit: Before play, secretly designate 3 enemy pieces as spies (King excluded). Record and conceal your selections.",
        "rules_2": "Activate: On your turn, announce a spy by label. The piece immediately defects to your color.",
        "rules_3": "Command: Activated spies remain under your control permanently, moving and capturing as your own.",
        "rules_4": "Limit: One activation per spy; 3 maximum per game. Captured pieces cannot be activated.",
        "rules_5": "It is important to remember that a reveal counts as a move.",
        "rules-turn-black": "Black may reveal after their 3rd turn.",
        "rules-turn-black-note": "On their 4th move",
        "rules-turn-white": "White may reveal after their 4th turn.",
        "rules-turn-white-note": "On their 5th move",
        "rules_7": "All standard chess rules still apply.",
        "rules-labels-title": "Labeling Convention (Piece Type + Starting File)",
        "piece-rook": "Rook",
        "piece-knight": "Knight",
        "piece-bishop": "Bishop",
        "piece-queen": "Queen",
        "piece-king": "King",
        "piece-pawn": "Pawn",
        "rules-king-excluded": "excluded from selection",
      },
    },
    es: {
      translation: {
        "main-title": "Ajedrez Espía",
        "instagram": "Instagram",
        "youtube": "YouTube",
        "tiktok": "TikTok",
        "website": "Sitio Web",
        "facebook": "Facebook",
        "X": "X",
        "google-play": "Google Play",
        "app-store": "App Store",
        "rules": "Reglas",
        "rules-title": "Reglas de Ajedrez Espía",
        "rules_1": "Reclutar: Antes de jugar, designa en secreto 3 piezas enemigas como espías (el Rey queda excluido). Anota y oculta tus selecciones.",
        "rules_2": "Activar: En tu turno, anuncia un espía por su etiqueta. La pieza se pasa inmediatamente a tu color.",
        "rules_3": "Comandar: Los espías activados permanecen bajo tu control de forma permanente, moviéndose y capturando como piezas propias.",
        "rules_4": "Límite: Una activación por espía; máximo 3 por partida. Las piezas capturadas no pueden ser activadas.",
        "rules_5": "Es importante recordar que una revelación cuenta como un movimiento.",
        "rules-turn-black": "Las negras pueden revelar después de su 3er turno.",
        "rules-turn-black-note": "En su 4to movimiento",
        "rules-turn-white": "Las blancas pueden revelar después de su 4to turno.",
        "rules-turn-white-note": "En su 5to movimiento",
        "rules_7": "Todas las reglas estándar del ajedrez siguen aplicando.",
        "rules-labels-title": "Convención de Etiquetado (Tipo de Pieza + Columna Inicial)",
        "piece-rook": "Torre",
        "piece-knight": "Caballo",
        "piece-bishop": "Alfil",
        "piece-queen": "Dama",
        "piece-king": "Rey",
        "piece-pawn": "Peón",
        "rules-king-excluded": "excluido de la selección",
      },
    },
    pt: {
      translation: {
        "main-title": "Xadrez Espião",
        "instagram": "Instagram",
        "youtube": "YouTube",
        "tiktok": "TikTok",
        "website": "Site",
        "facebook": "Facebook",
        "X": "X",
        "google-play": "Google Play",
        "app-store": "App Store",
        "rules": "Regras",
        "rules-title": "Regras de Xadrez Espião",
        "rules_1": "Recrutar: Antes de jogar, designe secretamente 3 peças inimigas como espiões (Rei excluído). Anote e oculte suas seleções.",
        "rules_2": "Ativar: Na sua vez, anuncie um espião pelo rótulo. A peça desertará imediatamente para a sua cor.",
        "rules_3": "Comandar: Os espiões ativados permanecem sob seu controle permanentemente, movendo-se e capturando como suas próprias peças.",
        "rules_4": "Limite: Uma ativação por espião; máximo de 3 por partida. Peças capturadas não podem ser ativadas.",
        "rules_5": "É importante lembrar que uma revelação conta como um movimento.",
        "rules-turn-black": "As pretas podem revelar após seu 3º turno.",
        "rules-turn-black-note": "Em seu 4º movimento",
        "rules-turn-white": "As brancas podem revelar após seu 4º turno.",
        "rules-turn-white-note": "Em seu 5º movimento",
        "rules_7": "Todas as regras padrão do xadrez ainda se aplicam.",
        "rules-labels-title": "Convenção de Rotulagem (Tipo de Peça + Coluna Inicial)",
        "piece-rook": "Torre",
        "piece-knight": "Cavalo",
        "piece-bishop": "Bispo",
        "piece-queen": "Dama",
        "piece-king": "Rei",
        "piece-pawn": "Peão",
        "rules-king-excluded": "excluído da seleção",
      },
    },
    fr: {
      translation: {
        "main-title": "Échecs Espion",
        "instagram": "Instagram",
        "youtube": "YouTube",
        "tiktok": "TikTok",
        "website": "Site Web",
        "facebook": "Facebook",
        "X": "X",
        "google-play": "Google Play",
        "app-store": "App Store",
        "rules": "Règles",
        "rules-title": "Règles des Échecs Espion",
        "rules_1": "Recruter : Avant de jouer, désignez secrètement 3 pièces ennemies comme espions (le Roi est exclu). Notez et dissimulez vos choix.",
        "rules_2": "Activer : À votre tour, annoncez un espion par son étiquette. La pièce rejoint immédiatement votre couleur.",
        "rules_3": "Commander : Les espions activés restent définitivement sous votre contrôle, se déplaçant et capturant comme vos propres pièces.",
        "rules_4": "Limite : Une activation par espion ; 3 maximum par partie. Les pièces capturées ne peuvent pas être activées.",
        "rules_5": "Il est important de se rappeler qu'une révélation compte comme un mouvement.",
        "rules-turn-black": "Les Noirs peuvent révéler après leur 3e tour.",
        "rules-turn-black-note": "À leur 4e coup",
        "rules-turn-white": "Les Blancs peuvent révéler après leur 4e tour.",
        "rules-turn-white-note": "À leur 5e coup",
        "rules_7": "Toutes les règles standard des échecs s'appliquent toujours.",
        "rules-labels-title": "Convention d'Étiquetage (Type de Pièce + Colonne de Départ)",
        "piece-rook": "Tour",
        "piece-knight": "Cavalier",
        "piece-bishop": "Fou",
        "piece-queen": "Dame",
        "piece-king": "Roi",
        "piece-pawn": "Pion",
        "rules-king-excluded": "exclu de la sélection",
      },
    },
    ru: {
      translation: {
        "main-title": "Шпионские Шахматы",
        "instagram": "Instagram",
        "youtube": "YouTube",
        "tiktok": "TikTok",
        "website": "Веб-сайт",
        "facebook": "Facebook",
        "X": "X",
        "google-play": "Google Play",
        "app-store": "App Store",
        "rules": "Правила",
        "rules-title": "Правила Шпионских Шахмат",
        "rules_1": "Вербовка: Перед началом игры тайно назначьте 3 фигуры противника шпионами (Король исключён). Запишите и скройте свой выбор.",
        "rules_2": "Активация: В свой ход объявите шпиона по метке. Фигура немедленно переходит на вашу сторону.",
        "rules_3": "Командование: Активированные шпионы остаются под вашим контролем до конца игры, двигаясь и делая взятия как ваши собственные фигуры.",
        "rules_4": "Ограничение: Одна активация на шпиона; максимум 3 за игру. Захваченные фигуры активировать нельзя.",
        "rules_5": "Важно помнить, что раскрытие считается ходом.",
        "rules-turn-black": "Чёрные могут раскрыть шпиона после своего 3-го хода.",
        "rules-turn-black-note": "На своём 4-м ходе",
        "rules-turn-white": "Белые могут раскрыть шпиона после своего 4-го хода.",
        "rules-turn-white-note": "На своём 5-м ходе",
        "rules_7": "Все остальные стандартные правила шахмат по-прежнему действуют.",
        "rules-labels-title": "Соглашение об обозначениях (Тип фигуры + начальная вертикаль)",
        "piece-rook": "Ладья",
        "piece-knight": "Конь",
        "piece-bishop": "Слон",
        "piece-queen": "Ферзь",
        "piece-king": "Король",
        "piece-pawn": "Пешка",
        "rules-king-excluded": "исключён из выбора",
      },
    },
    de: {
      translation: {
        "main-title": "Spion Schach",
        "instagram": "Instagram",
        "youtube": "YouTube",
        "tiktok": "TikTok",
        "website": "Webseite",
        "facebook": "Facebook",
        "X": "X",
        "google-play": "Google Play",
        "app-store": "App Store",
        "rules": "Regeln",
        "rules-title": "Spion Schach Regeln",
        "rules_1": "Rekrutieren: Bestimmen Sie vor dem Spiel heimlich 3 gegnerische Figuren als Spione (König ausgeschlossen). Notieren und verbergen Sie Ihre Auswahl.",
        "rules_2": "Aktivieren: Nennen Sie in Ihrem Zug einen Spion anhand seiner Bezeichnung. Die Figur wechselt sofort zu Ihrer Farbe.",
        "rules_3": "Befehligen: Aktivierte Spione bleiben dauerhaft unter Ihrer Kontrolle und ziehen sowie schlagen wie Ihre eigenen Figuren.",
        "rules_4": "Begrenzung: Eine Aktivierung pro Spion; maximal 3 pro Spiel. Geschlagene Figuren können nicht aktiviert werden.",
        "rules_5": "Es ist wichtig zu bedenken, dass eine Aufdeckung als Zug zählt.",
        "rules-turn-black": "Schwarz darf nach seinem 3. Zug aufdecken.",
        "rules-turn-black-note": "Bei seinem 4. Zug",
        "rules-turn-white": "Weiß darf nach seinem 4. Zug aufdecken.",
        "rules-turn-white-note": "Bei seinem 5. Zug",
        "rules_7": "Alle regulären Schachregeln gelten weiterhin.",
        "rules-labels-title": "Bezeichnungskonvention (Figurentyp + Startspalte)",
        "piece-rook": "Turm",
        "piece-knight": "Springer",
        "piece-bishop": "Läufer",
        "piece-queen": "Dame",
        "piece-king": "König",
        "piece-pawn": "Bauer",
        "rules-king-excluded": "von der Auswahl ausgeschlossen",
      },
    },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
